@import '../../../../../../constants/spacing.module.less';

@commonMargin: @space-32;

.hotkey-action-buttons {
  > button {
    margin-right: 10px;
  }
  &.quick-reference {
    margin-top: @commonMargin;
  }
}

.barcode-scan-quickref {
  display: flex;
  .barcode-selectors {
    width: 400px;
    margin-right: @commonMargin;
  }
}

.hotkey-report-example {
  padding: 20px;
}

.banner {
  margin-bottom: @space-32;
}
